
import {
  Vue, Component, Watch, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { calculateDateRange } from '@/features/common/helpers/moment';

@Component
export default class DateRangePicker extends Vue {
  @Prop({ required: false, default: true }) isFuture!: boolean;

  @Prop({ required: false, default: false }) enforceRangeOrder!: boolean;

  @Prop({ required: false, default: () => [] }) initialDates!: string[];

  private dateCalendar: string[] = [];

  private startDate = '';

  private endDate = '';

  mounted(): void {
    if (this.initialDates.length) {
      this.dateCalendar = [...this.initialDates];
    }
    this.formatDate();
  }

  @Watch('dateCalendar')
  private updateStartAndEndDate(newDate: string[]) {
    const sorted = this.sortDate([...newDate]);

    if (sorted.length >= 2) {
      [this.startDate, this.endDate] = sorted;
    } else if (sorted.length === 1) {
      [this.startDate] = sorted;
      this.endDate = '';
    } else {
      this.startDate = '';
      this.endDate = '';
    }

    this.formatDate();
  }

  private allowedDates(
    date: string,
    currentValue?: string | string[],
  ): boolean {
    const current = moment(date, 'YYYY-MM-DD');

    if (this.enforceRangeOrder && Array.isArray(currentValue) && currentValue.length === 1) {
      const start = moment(currentValue[0], 'YYYY-MM-DD');
      if (current.isBefore(start, 'day')) {
        return false;
      }
    }

    if (this.isFuture) return true;

    const tomorrowMoment = moment().add(1, 'days');
    return current.isBefore(tomorrowMoment, 'day');
  }

  private clearDate(indexToClear: number) {
    if (indexToClear === 0) {
      this.dateCalendar = [];
    } else if (this.dateCalendar.length === 2) {
      const sorted = this.sortDate([...this.dateCalendar]);
      this.dateCalendar = [sorted[0]];
    } else {
      this.dateCalendar = [];
    }
  }

  private applyFilter() {
    if (this.dateCalendar.length === 1) {
      this.closePicker();
      return;
    }

    let dateRange: string[] = [];

    if (this.dateCalendar.length) {
      dateRange = calculateDateRange([...this.sortDate(this.dateCalendar)]);
    } else {
      dateRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    }

    this.$emit('applyFilter', dateRange);
    this.closePicker();
  }

  private closePicker() {
    this.$emit('closePicker');
    this.startDate = '';
    this.endDate = '';
  }

  private formatDate() {
    this.startDate = this.startDate ? moment(this.startDate, 'YYYY-MM-DD').format('MMM D, YYYY') : '';
    this.endDate = this.endDate ? moment(this.endDate, 'YYYY-MM-DD').format('MMM D, YYYY') : '';
  }

  private sortDate = (cNewDate: string[]) => {
    return cNewDate.sort((a, b) => {
      return (+moment(a).format('X')) - (+moment(b).format('X'));
    });
  }
}
